import React from 'react';
import Box from '@mui/material/Box';
import Header from './components/Header';
import GridContainer from '../../../@jumbo/components/GridContainer';
import Grid from '@mui/material/Grid';
import Contact from './components/Contact';
import { useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Switch, useHistory, Route } from 'react-router';
import { AccountBox, ShoppingBasket } from '@mui/icons-material';
import ProfileDetails from './components/ProfileDetails';
import ProfileRequestHistories from './components/ProfileRequestHistories';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import ProfilePreviousProjects from './components/ProfilePreviousProjects';
import ProfilePreviousProject from './components/ProfilePreviousProject';
import useWidth from 'services/Hooks/useWidth';
import ProfileAwaitingRequests from './components/ProfileAwaitingRequests';
import OrderDetail from './components/OrderDetail';
import ExteriorSignageQuoteCheckout from '../ExteriorSignageQuote/ExteriorSignageQuoteCheckout';
import MerchandisingProgramQuoteCheckout from '../MerchandisingProgramQuote/MerchandisingProgramQuoteCheckout';
import { Slide } from '@mui/material';
import AssociatedCartSupportChats from '../Support/AssociatedCartSupportChats';
import AssociatedExteriorSignageQuoteSupportChats from '../Support/AssociatedExteriorSignageQuoteSupportChats';
import AssociatedMerchandisingProgramQuoteSupportChats from '../Support/AssociatedMerchandisingProgramQuoteSupportChats';

const useStyles = makeStyles(theme => ({
  pageFull: {
    width: '100%',
    paddingTop: 30,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
  },
}));

const Profile = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const width = useWidth();

  const accountReducer = useSelector(state => state.AccountReducer);

  const { profile } = accountReducer;

  let activeTab = history.location.pathname.includes('/awaiting-requests')
    ? 1
    : history.location.pathname.includes('/request-histories')
    ? 2
    : history.location.pathname.includes('/previous-projects')
    ? 3
    : history.location.pathname.includes('/identification')
    ? 4
    : 1; // defaultValue

  const changeUrl = index => {
    var routeName = tabs[index - 1].tabRoute;
    history.push(`/dealer/profile/${routeName}`);
  };

  const handleTabChange = (event, newValue) => {
    changeUrl(newValue);
  };

  const tabs = [
    {
      id: 1,
      title: t('pendingRequests'),
      tabRoute: 'awaiting-requests',
      icon: <ShoppingBasket />,
    },
    {
      id: 2,
      title: t('requestHistories'),
      tabRoute: 'request-histories',
      icon: <ShoppingBasket />,
    },
    {
      id: 3,
      title: t('previousProjects'),
      tabRoute: 'previous-projects',
      icon: <ApplicationIcons.Project />,
    },
    {
      id: 4,
      title: t('popup.profile'),
      tabRoute: 'identification',
      icon: <AccountBox />,
    },
  ];

  const routeUsingFullWidth = history.location.pathname.includes('/previous-projects/');

  return (
    <Slide direction="up" in mountOnEnter unmountOnExit>
      {profile && (
        <Box className={classes.pageFull}>
          <Header userDetail={profile} tabValue={activeTab} handleTabChange={handleTabChange} tabs={tabs} />
          <GridContainer>
            {(width === 'xs' || !routeUsingFullWidth) && (
              <Grid item xs={12} md={4} className={classes.profileSidebar}>
                <Box mb={6}>
                  <Contact userDetail={profile} />
                </Box>
                <Box mb={6}>
                  <Switch>
                    <Route
                      path="/dealer/profile/awaiting-requests/order/:cartId"
                      exact
                      render={() => <AssociatedCartSupportChats />}
                    />
                    <Route
                      path="/dealer/profile/awaiting-requests/exterior-signage-quote/:exteriorSignageQuoteId"
                      exact
                      render={() => <AssociatedExteriorSignageQuoteSupportChats />}
                    />
                    <Route
                      path="/dealer/profile/awaiting-requests/merchandising-program-quote/:merchandisingProgramQuoteId"
                      exact
                      render={() => <AssociatedMerchandisingProgramQuoteSupportChats />}
                    />

                    <Route
                      path="/dealer/profile/request-histories/order/:cartId"
                      exact
                      render={() => <AssociatedCartSupportChats disableSupportChat />}
                    />
                    <Route
                      path="/dealer/profile/request-histories/exterior-signage-quote/:exteriorSignageQuoteId"
                      exact
                      render={() => <AssociatedExteriorSignageQuoteSupportChats disableSupportChat />}
                    />
                    <Route
                      path="/dealer/profile/request-histories/merchandising-program-quote/:merchandisingProgramQuoteId"
                      exact
                      render={() => <AssociatedMerchandisingProgramQuoteSupportChats disableSupportChat />}
                    />
                  </Switch>
                </Box>
              </Grid>
            )}

            <Grid item xs={12} md={routeUsingFullWidth ? 12 : 8} className={classes.profileMainContent}>
              <Box mb={6}>
                <Switch>
                  <Route path="/dealer" exact render={() => <ProfileAwaitingRequests />} />
                  <Route path="/dealer/profile" exact render={() => <ProfileAwaitingRequests />} />
                  <Route path="/dealer/profile/request-histories" exact render={() => <ProfileRequestHistories />} />
                  <Route
                    path="/dealer/profile/request-histories/order/:cartId"
                    exact
                    render={() => <OrderDetail fromHistory />}
                  />
                  <Route
                    path="/dealer/profile/request-histories/exterior-signage-quote/:exteriorSignageQuoteId"
                    exact
                    render={() => <ExteriorSignageQuoteCheckout fromHistory />}
                  />

                  <Route
                    path="/dealer/profile/request-histories/merchandising-program-quote/:merchandisingProgramQuoteId"
                    exact
                    render={() => <MerchandisingProgramQuoteCheckout fromHistory />}
                  />

                  <Route path="/dealer/profile/awaiting-requests" exact render={() => <ProfileAwaitingRequests />} />
                  <Route path="/dealer/profile/awaiting-requests/order/:cartId" exact render={() => <OrderDetail />} />
                  <Route
                    path="/dealer/profile/awaiting-requests/exterior-signage-quote/:exteriorSignageQuoteId"
                    exact
                    render={() => <ExteriorSignageQuoteCheckout />}
                  />
                  <Route
                    path="/dealer/profile/awaiting-requests/merchandising-program-quote/:merchandisingProgramQuoteId"
                    exact
                    render={() => <MerchandisingProgramQuoteCheckout />}
                  />

                  <Route path="/dealer/profile/previous-projects" exact render={() => <ProfilePreviousProjects />} />
                  <Route
                    path="/dealer/profile/previous-projects/:projectId"
                    exact
                    render={() => <ProfilePreviousProject />}
                  />
                  <Route path="/dealer/profile/identification" exact render={() => <ProfileDetails />} />
                </Switch>
              </Box>
            </Grid>
          </GridContainer>
        </Box>
      )}
    </Slide>
  );
};

export default Profile;
